import { useState, useContext, useEffect } from 'react';
import { IonContent, IonPage, IonSelect, IonSelectOption } from '@ionic/react';
import Navbar from '../../components/Navbar';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { useIonViewDidEnter } from '@ionic/react';
import { ServerUrl, GetCurrentYear } from '../../constants';
import { AppContext } from "../../context/appContext";
import axios from 'axios';
import { BorderRight } from '@material-ui/icons';

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#E4E4E4'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
        border: '1px solid black'
    },
    viewer: {
        width: window.innerWidth, //the pdf viewer will take up all of the width and height
        height: window.innerHeight,
    },
});

const Home: React.FC = () => {
    const { CurrentUser } = useContext(AppContext);
    const token = CurrentUser ? CurrentUser.token : null;

    const [CurrentTotal, SetCurrentTotal] = useState<Array<any>>([]);
    const [CurrentBoard, SetCurrentBoard] = useState<Array<any>>([]);

    const [PreviousTotal, SetPreviousTotal] = useState<Array<any>>([]);
    const [PreviousBoard, SetPreviousBoard] = useState<Array<any>>([]);

    const [TotalCurrentSum, SetTotalCurrentSum] = useState<string>('');
    const [TotalPreviousSum, SetTotalPreviousSum] = useState<string>('');
    const [growTarget, SetGrowTarget] = useState<string>('');

    const [BoardCurrentSum, SetBoardCurrentSum] = useState<string>('');
    const [BoardPreviousSum, SetBoardPreviousSum] = useState<string>('');

    const [CurrentData, SetCurrentData] = useState<Array<any>>([]);
    const [PreviousData, SetPreviousData] = useState<Array<any>>([]);

    const [CurrentSum, SetCurrentSum] = useState<string>('');
    const [PreviousSum, SetPreviousSum] = useState<string>('');
    const [currentRegion, setCurrentRegion] = useState<string>("Region 1");
    const [pdfName, setPdfName] = useState("")

    const currentYear = GetCurrentYear() - 2000;
    let current_year = currentYear + '-' + (currentYear + 1);
    let previous_year = (currentYear - 1) + '-' + currentYear;

    const currentFullYear = GetCurrentYear();
    let current_full_year = currentFullYear + ' - ' + (currentFullYear + 1);
    let previous_full_year = (currentFullYear - 1) + ' - ' + currentFullYear;

    useIonViewDidEnter(() => {
        LoadData();
        setPdfName(currentRegion + "_monthly_" + current_year + ".pdf");
    });

    useEffect(() => {
        LoadData();
        setPdfName(currentRegion + "_monthly_" + current_year + ".pdf");
    }, [currentRegion]);

    const totalUrl = `${ServerUrl}/monthly/2.1a/total/region`;
    const boardUrl = `${ServerUrl}/monthly/2.1a/board/region`;
    const dataUrl = `${ServerUrl}/monthly/2.1/region`;
    const allUrl = `${ServerUrl}/monthly/all`;

    const LoadData = async () => {
        if (currentRegion == 'All') {
            const response = await fetch(`${allUrl}?current=${current_year}&previous=${previous_year + ""}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );
            const blob = await response.blob();

            // Create a URL for the blob object
            const url = URL.createObjectURL(blob);

            // Create a link element and simulate a click to download the file
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Monthly.zip';
            link.click();

            // Revoke the URL once the download is complete
            setTimeout(() => URL.revokeObjectURL(url), 60000);

        }
        else {
            axios.get(`${totalUrl}?year=${current_year}&region=${currentRegion + " ESC"}`, {
                headers: {
                    'Authorization': "Bearer " + token,
                }
            }).then(res => {
                if (res.data && res.data.length > 0) {
                    SetCurrentTotal(res.data);
                    SetTotalCurrentSum(getSum(res.data, current_year))
                }
            }, err => {
                alert("Fail to get data. " + JSON.stringify(err))
            });

            axios.get(`${totalUrl}?year=${previous_year}&region=${currentRegion + " ESC"}`, {
                headers: {
                    'Authorization': "Bearer " + token,
                }
            }).then(res => {
                if (res.data && res.data.length > 0) {
                    SetPreviousTotal(res.data);
                    let previousSum = getSum(res.data, previous_year);
                    let target = (parseFloat(previousSum) * 1.03).toFixed(2);
                    SetTotalPreviousSum(previousSum);
                    SetGrowTarget(target);
                }
            }, err => {
                console.log("Fail to get data. " + JSON.stringify(err))
            });

            axios.get(`${boardUrl}?year=${current_year}&region=${currentRegion + " ESC"}`, {
                headers: {
                    'Authorization': "Bearer " + token,
                }
            }).then(res => {
                if (res.data && res.data.length > 0) {
                    SetCurrentBoard(res.data);
                    SetBoardCurrentSum(getSum(res.data, current_year));
                }
            }, err => {
                alert("Fail to get data. " + JSON.stringify(err))
            });

            axios.get(`${boardUrl}?year=${previous_year}&region=${currentRegion + " ESC"}`, {
                headers: {
                    'Authorization': "Bearer " + token,
                }
            }).then(res => {
                if (res.data && res.data.length > 0) {
                    SetPreviousBoard(res.data);
                    SetBoardPreviousSum(getSum(res.data, previous_year));
                }
            }, err => {
                console.log("Fail to get data. " + JSON.stringify(err))
            });

            axios.get(`${dataUrl}?year=${current_year}&region=${currentRegion + " ESC"}`, {
                headers: {
                    'Authorization': "Bearer " + token,
                }
            }).then(res => {
                if (res.data && res.data.length > 0) {
                    SetCurrentData(res.data);
                    SetCurrentSum(getDataSum(res.data));
                }
            }, err => {
                alert("Fail to get data. " + JSON.stringify(err))
            });

            axios.get(`${dataUrl}?year=${previous_year}&region=${currentRegion + " ESC"}`, {
                headers: {
                    'Authorization': "Bearer " + token,
                }
            }).then(res => {
                if (res.data && res.data.length > 0) {
                    SetPreviousData(res.data);
                    SetPreviousSum(getDataSum(res.data));
                }
            }, err => {
                console.log("Fail to get data. " + JSON.stringify(err))
            });
        }
    };

    const getSum = (data: Array<any>, year: string): string => {
        let sum = 0;
        data.filter(element => element.year === year).forEach(item => sum += parseFloat(item.trainContactHours));
        return sum === 0 ? "0" : sum.toFixed(0);
    }

    const getData = (dataArray: Array<any>, name: string) => {
        let num = 0;

        let element = dataArray.find(e => e.month === name);
        if (element) {
            num = parseFloat(element.trainContactHours);
        }
        return num;
    }

    const getDataSum = (data: Array<any>): string => {
        let sum = 0;

        data.forEach(item => {
            let data = parseFloat(item.trainContactHours);
            if (!isNaN(data)) {
                sum += data;
            }
        });

        return sum === 0 ? sum.toString() : sum.toFixed(2);
    }

    const RenderRow = (name: string, data1: string, data2: string) => {
        return (
            <View style={{ height: '20px', display: 'flex', flexDirection: 'row' }}>
                <View style={{ flex: 1, borderRight: '1px solid black', borderBottom: '1px solid black', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
                    <Text>{name}</Text>
                </View>
                <View style={{ flex: 1, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <Text>{parseFloat(data1).toLocaleString()}</Text>
                </View>
                <View style={{ flex: 1, height: '100%', justifyContent: 'center', alignItems: 'center', borderBottom: '1px solid black', }}>
                    <Text>{parseFloat(data2).toLocaleString()}</Text>
                </View>
            </View>
        );
    }

    const GetTimeZone = () => {
        var offset = new Date().getTimezoneOffset();
        if (offset === 480) return "PST";
        else if (offset === 420) return "MST";
        else if (offset === 360) return "MST";
        else if (offset === 300) return "CST";
        else if (offset === 240) return "EST";
        return "";
    }

    const RenderPDF = () => {
        return (
            <>
                <Document>
                    <Page size="A4" style={{ flexDirection: 'column', padding: '20px', fontSize: '12px' }}>
                        <div style={{ width: '80%', marginLeft: '10%' }}>
                            
                            <View style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px', padding: '10px' }}>
                                <View style={{ justifyContent: 'center', alignItems: 'center', marginBottom: '4px', fontSize: '14px', fontWeight: 'bold' }}>
                                    <Text>Monthly Scorecard Report</Text>
                                </View>
                                <View style={{ justifyContent: 'center', alignItems: 'center', fontSize: '14px', fontWeight: 'bold' }}>
                                    <Text>{currentRegion} Education Service Center</Text>
                                </View>
                            </View>
                            <View style={{ fontSize: '12px', marginBottom: '10px', fontWeight: 'bold' }}>
                                <Text>Indicator 2.1</Text>
                                <Text>Number of Individuals Trained</Text>
                            </View>

                            <div style={{ borderRight: '1px solid black', borderTop: '1px solid black', borderLeft: '1px solid black', }}>
                                <View style={{ height: '40px', display: 'flex', flexDirection: 'row', fontWeight: 'bold', backgroundColor: 'lightgray' }}>
                                    <View style={{
                                        flex: 1, justifyContent: 'flex-end', alignItems: 'flex-start',
                                        borderRight: '1px solid black', borderBottom: '1px solid black'
                                    }}>
                                        <Text>Month</Text>
                                    </View>
                                    <View style={{ flex: 1, borderRight: '1px solid black', borderBottom: '1px solid black', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Text>Total Individuals Trained</Text>
                                        <Text>{current_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 1, justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black' }}>
                                        <Text>Total Individuals Trained</Text>
                                        <Text>{previous_full_year}</Text>
                                    </View>
                                </View>

                                {RenderRow("September", getData(CurrentTotal, 'September').toString(), getData(PreviousTotal, 'September').toString())}
                                {RenderRow("October", getData(CurrentTotal, 'October').toString(), getData(PreviousTotal, 'October').toString())}
                                {RenderRow("November", getData(CurrentTotal, 'November').toString(), getData(PreviousTotal, 'November').toString())}
                                {RenderRow("December", getData(CurrentTotal, 'December').toString(), getData(PreviousTotal, 'December').toString())}
                                {RenderRow("January", getData(CurrentTotal, 'January').toString(), getData(PreviousTotal, 'January').toString())}
                                {RenderRow("February", getData(CurrentTotal, 'February').toString(), getData(PreviousTotal, 'February').toString())}
                                {RenderRow("March", getData(CurrentTotal, 'March').toString(), getData(PreviousTotal, 'March').toString())}
                                {RenderRow("April", getData(CurrentTotal, 'April').toString(), getData(PreviousTotal, 'April').toString())}
                                {RenderRow("May", getData(CurrentTotal, 'May').toString(), getData(PreviousTotal, 'May').toString())}
                                {RenderRow("June", getData(CurrentTotal, 'June').toString(), getData(PreviousTotal, 'June').toString())}
                                {RenderRow("July", getData(CurrentTotal, 'July').toString(), getData(PreviousTotal, 'July').toString())}
                                {RenderRow("August", getData(CurrentTotal, 'August').toString(), getData(PreviousTotal, 'August').toString())}
                                {RenderRow("Total", getSum(CurrentTotal, current_year), getSum(PreviousTotal, previous_year))}
                            </div>

                            <div style={{ borderRight: '1px solid black', borderTop: '1px solid black', borderLeft: '1px solid black', marginTop: '20px' }}>
                                <View style={{ height: '40px', display: 'flex', flexDirection: 'row', fontWeight: 'bold', backgroundColor: 'lightgray' }}>
                                    <View style={{
                                        flex: 1, height: '40px', justifyContent: 'flex-end', alignItems: 'flex-start',
                                        borderRight: '1px solid black', borderBottom: '1px solid black'
                                    }}>
                                        <Text>Month</Text>
                                    </View>

                                    <View style={{ flex: 1, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Text>Board Members Trained</Text>
                                        <Text>{current_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 1, height: '100%', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black' }}>
                                        <Text>Board Members Trained</Text>
                                        <Text>{previous_full_year}</Text>
                                    </View>
                                </View>

                                {RenderRow("September", getData(CurrentBoard, 'September').toString(), getData(PreviousBoard, 'September').toString())}
                                {RenderRow("October", getData(CurrentBoard, 'October').toString(), getData(PreviousBoard, 'October').toString())}
                                {RenderRow("November", getData(CurrentBoard, 'November').toString(), getData(PreviousBoard, 'November').toString())}
                                {RenderRow("December", getData(CurrentBoard, 'December').toString(), getData(PreviousBoard, 'December').toString())}
                                {RenderRow("January", getData(CurrentBoard, 'January').toString(), getData(PreviousBoard, 'January').toString())}
                                {RenderRow("February", getData(CurrentBoard, 'February').toString(), getData(PreviousBoard, 'February').toString())}
                                {RenderRow("March", getData(CurrentBoard, 'March').toString(), getData(PreviousBoard, 'March').toString())}
                                {RenderRow("April", getData(CurrentBoard, 'April').toString(), getData(PreviousBoard, 'April').toString())}
                                {RenderRow("May", getData(CurrentBoard, 'May').toString(), getData(PreviousBoard, 'May').toString())}
                                {RenderRow("June", getData(CurrentBoard, 'June').toString(), getData(PreviousBoard, 'June').toString())}
                                {RenderRow("July", getData(CurrentBoard, 'July').toString(), getData(PreviousBoard, 'July').toString())}
                                {RenderRow("August", getData(CurrentBoard, 'August').toString(), getData(PreviousBoard, 'August').toString())}
                                {RenderRow("Total", getSum(CurrentBoard, current_year), getSum(PreviousBoard, previous_year))}
                            </div>

                            <View style={{ height: '30px', display: 'flex', flexDirection: 'row', marginTop: '30px', justifyContent: 'space-between' }}>
                                <View>
                                    <Text></Text>
                                </View>
                                <View>
                                    <Text>{new Date().toLocaleString()} {GetTimeZone()}</Text>
                                </View>
                            </View>
                        </div>
                    </Page>

                    <Page size="A4" style={{ flexDirection: 'column', padding: '20px', fontSize: '12px' }}>
                        <div style={{ width: '80%', marginLeft: '10%' }}>
                            <View style={{ fontSize: '12px', marginBottom: '10px', fontWeight: 'bold', marginTop: '100px' }}>
                                <Text>Indicator 2.1a</Text>
                                <Text>Training Contact Hours Delivered</Text>
                            </View>

                            <div style={{ borderRight: '1px solid black', borderTop: '1px solid black', borderLeft: '1px solid black', marginTop: '20px' }}>
                                <View style={{ height: '40px', display: 'flex', flexDirection: 'row', fontWeight: 'bold', backgroundColor: 'lightgray' }}>
                                    <View style={{
                                        flex: 1, height: '40px', justifyContent: 'flex-end', alignItems: 'flex-start',
                                        borderRight: '1px solid black', borderBottom: '1px solid black'
                                    }}>
                                        <Text>Month</Text>
                                    </View>
                                    <View style={{ flex: 1, borderRight: '1px solid black', borderBottom: '1px solid black', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Text>Training Contact Hours</Text>
                                        <Text>{current_full_year}</Text>
                                    </View>
                                    <View style={{ flex: 1, height: '100%', justifyContent: 'flex-end', alignItems: 'center', borderBottom: '1px solid black' }}>
                                        <Text>Training Contact Hours</Text>
                                        <Text>{previous_full_year}</Text>
                                    </View>
                                </View>

                                {RenderRow("September", getData(CurrentData, 'September').toString(), getData(PreviousData, 'September').toString())}
                                {RenderRow("October", getData(CurrentData, 'October').toString(), getData(PreviousData, 'October').toString())}
                                {RenderRow("November", getData(CurrentData, 'November').toString(), getData(PreviousData, 'November').toString())}
                                {RenderRow("December", getData(CurrentData, 'December').toString(), getData(PreviousData, 'December').toString())}
                                {RenderRow("January", getData(CurrentData, 'January').toString(), getData(PreviousData, 'January').toString())}
                                {RenderRow("February", getData(CurrentData, 'February').toString(), getData(PreviousData, 'February').toString())}
                                {RenderRow("March", getData(CurrentData, 'March').toString(), getData(PreviousData, 'March').toString())}
                                {RenderRow("April", getData(CurrentData, 'April').toString(), getData(PreviousData, 'April').toString())}
                                {RenderRow("May", getData(CurrentData, 'May').toString(), getData(PreviousData, 'May').toString())}
                                {RenderRow("June", getData(CurrentData, 'June').toString(), getData(PreviousData, 'June').toString())}
                                {RenderRow("July", getData(CurrentData, 'July').toString(), getData(PreviousData, 'July').toString())}
                                {RenderRow("August", getData(CurrentData, 'August').toString(), getData(PreviousData, 'August').toString())}
                                {RenderRow("Total", getSum(CurrentData, current_year), getSum(PreviousData, previous_year))}
                            </div>

                            <View style={{ height: '30px', display: 'flex', flexDirection: 'row', marginTop: '300px', justifyContent: 'space-between' }}>
                                <View>
                                    <Text></Text>
                                </View>
                                <View>
                                    <Text>{new Date().toLocaleString()} {GetTimeZone()}</Text>
                                </View>
                            </View>
                        </div>
                    </Page>

                </Document>
            </>
        )
    };

    return (
        <IonPage>
            <Navbar />
            <IonContent fullscreen>
                <div style={{ padding: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    Select a Region
                    <div style={{ padding: '0px 10px 0px 10px', border: '1px solid black', borderRadius: '4px', margin: '0px 10px' }}>
                        <IonSelect placeholder="Select a role" value={currentRegion} onIonChange={(e) => setCurrentRegion((e.target as HTMLInputElement).value)}>
                            <IonSelectOption value="Region 1">Region 1</IonSelectOption>
                            <IonSelectOption value="Region 2">Region 2</IonSelectOption>
                            <IonSelectOption value="Region 3">Region 3</IonSelectOption>
                            <IonSelectOption value="Region 4">Region 4</IonSelectOption>
                            <IonSelectOption value="Region 5">Region 5</IonSelectOption>
                            <IonSelectOption value="Region 6">Region 6</IonSelectOption>
                            <IonSelectOption value="Region 7">Region 7</IonSelectOption>
                            <IonSelectOption value="Region 8">Region 8</IonSelectOption>
                            <IonSelectOption value="Region 9">Region 9</IonSelectOption>
                            <IonSelectOption value="Region 10">Region 10</IonSelectOption>
                            <IonSelectOption value="Region 11">Region 11</IonSelectOption>
                            <IonSelectOption value="Region 12">Region 12</IonSelectOption>
                            <IonSelectOption value="Region 13">Region 13</IonSelectOption>
                            <IonSelectOption value="Region 14">Region 14</IonSelectOption>
                            <IonSelectOption value="Region 15">Region 15</IonSelectOption>
                            <IonSelectOption value="Region 16">Region 16</IonSelectOption>
                            <IonSelectOption value="Region 17">Region 17</IonSelectOption>
                            <IonSelectOption value="Region 18">Region 18</IonSelectOption>
                            <IonSelectOption value="Region 19">Region 19</IonSelectOption>
                            <IonSelectOption value="Region 20">Region 20</IonSelectOption>
                            <IonSelectOption value="All">All</IonSelectOption>
                        </IonSelect>
                    </div>
                    <PDFDownloadLink document={RenderPDF()} fileName={pdfName}>
                        {({ blob, url, loading, error }) =>
                            loading ? 'Loading document...' : pdfName
                        }
                    </PDFDownloadLink>
                </div>

                <PDFViewer style={styles.viewer}>
                    {RenderPDF()}
                </PDFViewer>
            </IonContent>
        </IonPage>
    );
};

export default Home;
